import { AlertType } from "./alert-type";

export class Alert {
    type: AlertType;
    message: string;
    alertId: string;
    keepAfterRouteChange: boolean;

   // Explaination: The Alert constructor takes an optional parameter init,
   //which is a partial instance of Alert.A Partial<T> type in TypeScript
   // means that all properties of T are optional.
    constructor(init?: Partial<Alert>) {
        Object.assign(this, init);  // tis assigns properties of init to this, the instance of Alert
    }
}